/**
 * Track background sync status globally
 * Shows user when data is syncing or has sync problems
 */

const isSyncing = ref(false)
const lastSyncError = ref<string | null>(null)
const lastSyncTime = ref<number | null>(null)

export function useSyncStatus() {
  const startSync = () => {
    isSyncing.value = true
    lastSyncError.value = null
  }

  const completeSync = () => {
    isSyncing.value = false
    lastSyncTime.value = Date.now()
    lastSyncError.value = null
  }

  const failSync = (error: string) => {
    isSyncing.value = false
    lastSyncError.value = error
  }

  const hasSyncError = computed(() => !!lastSyncError.value)

  const syncStatusText = computed(() => {
    if (isSyncing.value) {
      return 'Synchronisiere...'
    }
    if (lastSyncError.value) {
      return 'Sync-Fehler'
    }
    if (lastSyncTime.value) {
      return 'Synchronisiert'
    }
    return ''
  })

  return {
    isSyncing: readonly(isSyncing),
    lastSyncError: readonly(lastSyncError),
    lastSyncTime: readonly(lastSyncTime),
    hasSyncError,
    syncStatusText,
    startSync,
    completeSync,
    failSync
  }
}
